import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import MoreModal from "../../../globalComponents/MoreModal/MoreModal";
import ConfirmModal from "../../../globalComponents/ConfirmModal/ConfirmModal";
import InfiniteScroll from "react-infinite-scroll-component";
import SmallLoading from "../../../globalComponents/Loading/components/SmallLoading/SmallLoading";
import TeacherPaymentCard from "./TeacherPaymentCard";
import { useLocation } from "react-router-dom";

const TeacherPaymentData = ({ getNextTeachers, userData }) => {
  const location = useLocation();
  const { hasMore, teachersPayments, teachersSalaries } = useSelector(
    (state) => state.teachersPaymentPagination
  );

  const [openMoreModal, setOpenMoreModal] = useState(false);
  const { openConfirmModal } = useSelector((state) => state.teachersModal);
  const [scrollHeight, setScrollHeight] = useState(1);

  const tableHead = [
    { id: 1, label: "Təlimçi adı" },
    { id: 2, label: "Fin" },
    { id: 3, label: "Seriya" },
    { id: 5, label: "Email" },
    { id: 6, label: "Mobil nömrə" },
    { id: 7, label: "Fənn / Əməkhaqqı" },
    { id: 10, label: "" },
  ];

  const tablePaymentHead = [
    { id: 1, label: "Təlimçi adı" },
    { id: 2, label: "Qrup adı" },
    { id: 3, label: "Keçirilmiş dərs sayı" },
    { id: 5, label: "1 dərs üzrə razılaşdırılmış ə/h" },
    { id: 6, label: "Qrup üzrə total ə/h" },
    { id: 7, label: "Total ə/h" },
  ];

  useEffect(() => {
    if (openMoreModal) {
      document.body.style.overflowY = "hidden";
    } else {
      document.body.style.overflowY = "overlay";
    }
  }, [openMoreModal]);

  useEffect(() => {
    const mainHeader = document.querySelector(".main-header");
    const detailsHeader = document.querySelector(".details-header");
    const globalHeads = document.querySelector(".global-head-tabs");

    const handleResize = () => {
      setScrollHeight(
        window.innerHeight -
          mainHeader.offsetHeight -
          detailsHeader.offsetHeight -
          globalHeads.offsetHeight
      );
    };

    setScrollHeight(
      window.innerHeight -
        mainHeader.offsetHeight -
        detailsHeader.offsetHeight -
        globalHeads.offsetHeight
    );

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  if (
    (location.pathname === "/teachers-payments" ||
      location.pathname === "/teachers-payments/mentors-payments") &&
    teachersSalaries?.length === 0
  ) {
    return <SmallLoading />;
  }

  return (
    <>
      <>
        {openMoreModal && (
          <MoreModal
            setOpenMoreModal={setOpenMoreModal}
            type="teacher"
            userData={userData}
          />
        )}
        {openConfirmModal && <ConfirmModal type="teacher" />}
        {location.pathname !== "/teachers-payments" &&
        location.pathname !== "/teachers-payments/mentors-payments" ? (
          <InfiniteScroll
            dataLength={teachersPayments.length}
            next={getNextTeachers}
            hasMore={hasMore}
            loader={<SmallLoading />}
            endMessage={
              <p style={{ textAlign: "center", fontSize: "20px" }}></p>
            }
            height={scrollHeight}
            scrollThreshold={0.7}
          >
            <table
              className={`details-table  teacher-table ${
                userData.power === "only-show" ? "only-show" : "update"
              } `}
            >
              <thead>
                <tr>
                  {tableHead.map((head, i) => (
                    <th
                      key={i}
                      className={`table-head-w ${
                        head.label === "Fin"
                          ? "teacher-fin-w"
                          : head.label === "Təlimçi adı"
                          ? "teacher-name-w"
                          : head.label === "Email"
                          ? "phone-w"
                          : head.label === "Fənn"
                          ? "lesson-w"
                          : head.label === "Qoşulma tarixi"
                          ? "created-w"
                          : head.label === "Status"
                          ? "status-w"
                          : head.label === "Doğum tarixi"
                          ? "student-birthday-w"
                          : head.label === "Seriya"
                          ? "teacher-seria-w"
                          : head.label === "Qrup adı"
                          ? "salary-group-w"
                          : ""
                      } `}
                    >
                      {head.label}
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {teachersPayments?.map((teacher, i) => (
                  <TeacherPaymentCard
                    key={teacher._id}
                    data={teacher}
                    mode="desktop"
                    teacher={userData}
                    cellNumber={i + 1}
                    setOpenMoreModal={setOpenMoreModal}
                  />
                ))}
              </tbody>
            </table>
          </InfiniteScroll>
        ) : (
          <InfiniteScroll
            dataLength={teachersPayments.length}
            hasMore={false}
            height={scrollHeight}
            scrollThreshold={0.7}
          >
            <table
              className={`details-table  teacher-table ${
                userData.power === "only-show" ? "only-show" : "update"
              } `}
            >
              <thead>
                <tr>
                  {tablePaymentHead.map((head, i) => (
                    <th
                      key={i}
                      style={{
                        width: i === 0 ? "200px" : "150px",
                        backgroundColor: "white",
                        textAlign: "start",
                      }}
                      className="table-head-w"
                    >
                      {head.label}
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {teachersSalaries?.map((teacher, i) => (
                  <TeacherPaymentCard
                    key={teacher?.teacher._id}
                    data={teacher}
                    mode="desktop"
                    teacher={userData}
                    cellNumber={i + 1}
                    setOpenMoreModal={setOpenMoreModal}
                    type={"payment"}
                  />
                ))}
                <tr>
                  <td>Ödənişin ümumi məbləği</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td style={{ textAlign: "left" }}>
                    {teachersSalaries?.reduce(
                      (total, current) => total + current.totalSalary,
                      0
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </InfiniteScroll>
        )}
      </>
    </>
  );
};

export default TeacherPaymentData;
